export const InputPatternRule = {
  pattern: /^[a-zA-Z0-9\s.,&\-_@]+$/,
  message: 'Only alphabets, numerals, spaces, and the following characters are allowed: . , & - _@',
};
export const InputPatternRuleDomainAdminDn = {
  pattern: /^[a-zA-Z0-9\s.,&\-_=]+$/,
  message: 'Only alphabets, numerals, spaces, and the following characters are allowed: . , & - _ =',
};
export const InputPatternRuleBrandingUrl = {
  pattern: /^[^\s\/]+$/,
  message: 'Please enter a valid domain',
};
export const InputPatternRuleEndpointDomain = {
  pattern: /^(?!.*[:\/])[^\s:\/]+$/,
  message: 'Please enter a valid domain',
};
export const InputPatternRuleAD = {
  pattern: /[\/\\[\];|=,+*?<>@"\]]/g,
  message: ` contains one or more of the following illegal characters: / \\ [ ] ; | = , + * ? < > @"
  <br>If you continue, it will automatically replace these characters with underscores ('_').<br>
  Do you want to continue?`,
};
